import { IPayerOnboardingSagaContext } from './payer-onboarding-saga-context';
import { observe, IValueDidChange } from 'mobx';
import { PayerOnboardingPage } from './pages';
import { convertLocalDateToUtcForLogs } from '../Shared/utils/date-helper';
import { GoogleAnalyticsWrapper } from '../WebGiving/infrastructure/google-analytics-wrapper';
import { IPayerOnboardingPageViewModel } from './pages/payer-onboarding-page-view-model';

export function recordPageStats(sagaContext: IPayerOnboardingSagaContext) {
	const { dataService, mainViewModel, appState } = sagaContext;
	const { viewData } = mainViewModel;

	observe(mainViewModel, 'currentPageViewModel', pageChanged, true);

	function pageChanged(change: IValueDidChange<IPayerOnboardingPageViewModel>) {
		const newPageType = change.newValue.type;

		dataService.recordPageStats({
			model: {
					PageName: PayerOnboardingPage[newPageType],
					Timestamp: convertLocalDateToUtcForLogs(moment()),
					InvitationToken: viewData.InvitationToken,
				},
			}, appState).catch(e => mainViewModel.reportError(e, newPageType));

		GoogleAnalyticsWrapper.pageView(PayerOnboardingPage[newPageType]);

		rg4js('trackEvent', { type: 'pageView', path: `/${PayerOnboardingPage[newPageType]}` });
	}
}
